import script from "./OrganizationListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationListView.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationListView.vue?vue&type=style&index=0&id=f83ff2dc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f83ff2dc"]])

export default __exports__